export enum AttendanceStatusEnum {
  OVERTIME = "OVERTIME",
  PENDING = "PENDING",
  IN_PROGRESS = "IN_PROGRESS",
  PAUSED = "PAUSED",
  CLOSED = "CLOSED"
}